import { throwError } from 'rxjs/internal/observable/throwError';

// Error handling
export const handleError = (error: any) => {
  let errorMessage = '';
  if (error.error instanceof ErrorEvent) {
    // Get client-side error
    errorMessage = error.error.message;
  } else {
    // Get server-side error
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
  return throwError(() => {
    return errorMessage;
  });
};
